import React, { useState } from "react";
import Modal from "react-modal";
import { useStateValue } from "../../StateProvider";
import { getDefaultValue } from "../../utils";
import ModalRules from "./ModalRules";

/**
 * Terms copy, checkbox, link to full rules, and validation message — for use above Participate (no dialog).
 */
export function AcceptRulesBlock({
  checked,
  onCheckedChange,
  rulesError,
  inputId = "accept-rules-checkbox",
}) {
  const [rulesModalOpen, setRulesModalOpen] = useState(false);

  const [{ translations }] = useStateValue();
  const translate = (str) => {
    if (!translations) return str;
    const tr = translations.find((x) => x.key === str);
    if (tr) return getDefaultValue(tr);
    return "#" + str;
  };

  return (
    <>
      <div className="accept-rules-inline lan-rtl kfont">
        <label className="accept-rules-inline__choice" htmlFor={inputId}>
          <input
            id={inputId}
            type="checkbox"
            checked={checked}
            onChange={(e) => onCheckedChange(e.target.checked)}
            className="accept-rules-inline__input"
          />
          <span className="accept-rules-inline__check" aria-hidden="true">
            <i className="fas fa-check" />
          </span>
          <span className="accept-rules-inline__label">
            {translate("I accept rules and conditions")}
          </span>
        </label>
        <p className="accept-rules-inline__help">
          <a
            href="#rules"
            onClick={(e) => {
              e.preventDefault();
              setRulesModalOpen(true);
            }}
          >
            <i className="fas fa-file-alt" aria-hidden="true" />
            {translate("kurdish talent rules")}
          </a>
        </p>
        {rulesError && (
          <div className="accept-rules-inline__error" role="alert">
            <i className="fas fa-exclamation-circle" aria-hidden="true" />
            {rulesError}
          </div>
        )}
      </div>
      <ModalRules isOpen={rulesModalOpen} setIsOpen={setRulesModalOpen} />
    </>
  );
}

function ModalAcceptRules({ isOpen = false, setIsOpen, onAccept }) {
  const [checked, setChecked] = useState(false);
  const [rules_error, setRulesError] = useState(null);

  const [{ translations }] = useStateValue();
  const translate = (str) => {
    if (!translations) return str;
    const tr = translations.find((x) => x.key === str);
    if (tr) return getDefaultValue(tr);
    return "#" + str;
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const onSubmit = () => {
    setRulesError("");
    if (!checked) {
      setRulesError(translate("Please accept terms and condititions"));
      return;
    }
    setIsOpen(false);
    if (typeof onAccept === "function") {
      onAccept();
    }
  };

  return (
    <Modal
      closeTimeoutMS={500}
      isOpen={isOpen}
      onRequestClose={closeModal}
      className="Modal"
      overlayClassName="Overlay"
      ariaHideApp={false}
    >
      <div className="modal-content lan-rtl">
        <div className="modal-header ">
          <h4
            className="modal-title lan-text-right"
            id="defaultModalLabel"
          >
            {translate("Participate in competition")}
          </h4>
          <button
            type="button"
            className="close lan-float-left lan-ml-0"
            onClick={closeModal}
          >
            &times;
          </button>
        </div>
        <div className="modal-body ">
          <AcceptRulesBlock
            checked={checked}
            onCheckedChange={setChecked}
            rulesError={rules_error}
            inputId="rules-modal-accept"
          />
        </div>
        <div className="modal-footer">
          <button className="pull-right btn btn-primary" onClick={onSubmit}>
            {translate("Submit participate")}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ModalAcceptRules;
